import { Content } from 'antd/lib/layout/layout';
import styled from 'styled-components';

export const ContentDashboardStyled = styled(Content)`
  padding: 15px 15px;
`;
